// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"761a7c86","383":"c49e6faa","654":"7fa80b89","787":"60235f71","955":"2e85f6a1"}[chunkId] + ".chunk.js";
};